export default {
  select_size: 'Wähle eine Größe',
  required: 'Pflichtfeld',
  required_missing: 'Pflichtfeld — bitte triff eine Auswahl',
  optional: 'Optional',
  select_up_to: 'Wähle bis zu {{maxCount}}',
};
